import { useMutation } from "@apollo/client";
import { READ_NOTIFICATION } from "@/modules/common/features/read-notification/api/read-notification";

export function useReadNotification() {
  const [readNotification, { loading, client }] =
    useMutation(READ_NOTIFICATION);

  const read = async (ids: string | string[]) => {
    await readNotification({
      variables: {
        ids,
      },
      onCompleted: async () => {
        const idsArray = Array.isArray(ids) ? ids : [ids];

        idsArray.forEach((id) => {
          client.cache.modify({
            id: `NotificationDto:${id}`,
            fields: {
              wasRead: () => true,
            },
          });
        });
      },
    });
  };

  return {
    read,
    loading,
  };
}
